module.exports = __webpack_public_path__ + "img/bllc13.1cde8b0b.png";